<div class="padding flex column">
	<b class="margin-bottom-small">Change Status</b>

	<!-- <form (ngSubmit)="search()">
		<div class="flex center">
			<input type="text" class="flex-1" [(ngModel)]="searchFilter" />
			<button class="margin-left-smallest">
				<i class="fa-solid fa-search margin-right-small"></i>
				Search
			</button>
		</div>
	</form> -->

	<!-- <mat-chip-set class="margin-top-small">
		@for (element of datasourceSelected; track element.displayId) {
			<mat-chip-row class="hover" (removed)="onRemove(element)" (click)="onRemove(element)">
				{{ element.displayName }}
				<mat-icon matChipRemove>close</mat-icon>
			</mat-chip-row>
		}
	</mat-chip-set> -->

	<!-- <div class="flex column margin-top-small flex-1 scrollable">
		@for (element of datasource; track element.displayId) {
			<mat-checkbox
				[checked]="element.selected"
				class="margin-bottom-small"
				(change)="onClick(element)"
				inViewport
				(inViewportAction)="inViewportAction($event, element)">
				{{ element.displayName }}
			</mat-checkbox>
		}
	</div> -->
	<div class="flex center">

		<mat-form-field appearance="outline">
			<mat-label>From Status</mat-label>
			<mat-select matNativeControl [value]="data.actualStatusId" disabled>
				@for(status of datasource; track status){
					<mat-option [value]="status.id">{{status.name}}</mat-option>
				}
			</mat-select>
		  </mat-form-field>

		  <mat-icon>arrow_forward</mat-icon>

		<mat-form-field appearance="outline">
			<mat-label>To Status</mat-label>
			<mat-select matNativeControl [(ngModel)]="selectedStatus">
				@for(status of datasource; track status){
					<mat-option [disabled]="status.id === data.actualStatusId" [value]="status.id">{{status.name}}</mat-option>
				}
			</mat-select>
		  </mat-form-field>


	</div>

	<div class="flex column end margin-top-small">
		<div class="flex center">
			<button class="stroked margin-right-small" (click)="onClose()">
				<i class="fa-solid fa-rotate-left margin-right-small"></i>
				Discard
			</button>
			<button [mat-dialog-close]="selectedStatus" cdkFocusInitial>
				<i class="fa-solid fa-check margin-right-small"></i>
				Apply
			</button>
		</div>
	</div>
</div>
